module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_2.01385181.png";